import React from 'react';

const FilterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="currentColor" fillRule="evenodd">
      <path d="M5 20V4h2v16zM11 20V4h2v16zM17 20V4h2v16z" />
      <path d="M3 8V6h6v2zM9 18v-2h6v2zM15 12v-2h6v2z" />
    </g>
  </svg>
);

export default FilterIcon;
